export const getBoolByLsnCode = (code) => ({
    isOscillation1: code === 'oscillation1',
    isOscillation2: code === 'oscillation2',
})